import { supabase } from '@/lib/supabase';

export interface ShopTrophy {
    id: number;
    shop_id: number;
    name: string;
    value: number;
    prize: string;
}

export interface ShopTrophyProgress {
    client_id: string;
    value: number;
    shop_id: number;
}

export const fetchShopTrophies = async (shopId: number): Promise<ShopTrophy[]> => {
    const { data, error } = await supabase
        .from('ShopTrophies')
        .select('*')
        .eq('shop_id', shopId)
        .order('value', { ascending: true });

    if (error) {
        console.error('Error fetching trophies:', error);
        throw error;
    }

    return data || [];
};

export const createShopTrophy = async (trophy: Omit<ShopTrophy, 'id'>): Promise<ShopTrophy> => {
    const { data, error } = await supabase
        .from('ShopTrophies')
        .insert([trophy])
        .select()
        .single();

    if (error) {
        console.error('Error creating trophy:', error);
        throw error;
    }

    return data;
};

export const updateShopTrophy = async (id: number, updates: Partial<ShopTrophy>): Promise<ShopTrophy> => {
    const { data, error } = await supabase
        .from('ShopTrophies')
        .update(updates)
        .eq('id', id)
        .select()
        .single();

    if (error) {
        console.error('Error updating trophy:', error);
        throw error;
    }

    return data;
};

export const deleteShopTrophy = async (id: number): Promise<void> => {
    const { error } = await supabase
        .from('ShopTrophies')
        .delete()
        .eq('id', id);

    if (error) {
        console.error('Error deleting trophy:', error);
        throw error;
    }
};

export const fetchShopTrophiesProgress = async (shopId: number): Promise<ShopTrophyProgress[]> => {
    const { data, error } = await supabase
        .from('ShopTrophiesProgress')
        .select('*')
        .eq('shop_id', shopId);

    if (error) {
        console.error('Error fetching trophies progress:', error);
        throw error;
    }

    return data || [];
};